export function getFileExtension(file: File): string {
  if (!file) {
    return ''
  }

  const [, _ext] = /\.(\w+)$/.exec(file.name) ?? []
  const ext = _ext?.toLowerCase() === 'jpeg' ? 'jpg' : _ext

  return ext ?? ''
}
